import { useCallback } from 'react';
import ChartWrapper from 'lib/visualization/charts/ChartWrapper/ChartWrapper';
import TimeSeriesTooltip from 'lib/uPlotV2/components/Tooltip/TimeSeriesTooltip';
import {
	TimeSeriesTooltipProps,
	TooltipRenderArgs,
} from 'lib/uPlotV2/components/types';

import { StackMode } from 'lib/uPlotV2/config/types';

import { TimeSeriesChartProps } from 'lib/visualization/charts/types';

export default function TimeSeries(props: TimeSeriesChartProps): JSX.Element {
	const { children, customTooltip, stack = StackMode.None, ...rest } = props;

	// Written during render so it lands before UPlotChart's effect reads the config,
	// which derives the fill bands, percent axis unit and percent range from it.
	rest.config.setStackMode(stack);

	const renderTooltip = useCallback(
		(props: TooltipRenderArgs): React.ReactNode => {
			if (customTooltip) {
				return customTooltip(props);
			}
			const tooltipProps: TimeSeriesTooltipProps = {
				...props,
				id: rest.config.getId(),
				timezone: rest.timezone,
				yAxisUnit: rest.yAxisUnit,
				decimalPrecision: rest.decimalPrecision,
				canPinTooltip: rest.canPinTooltip,
				renderTooltipFooter: rest.renderTooltipFooter,
			};
			return <TimeSeriesTooltip {...tooltipProps} />;
		},
		[
			customTooltip,
			rest.timezone,
			rest.yAxisUnit,
			rest.decimalPrecision,
			rest.canPinTooltip,
			rest.renderTooltipFooter,
		],
	);

	return (
		<ChartWrapper {...rest} customTooltip={renderTooltip}>
			{children}
		</ChartWrapper>
	);
}
